import { render, staticRenderFns } from "./OrganizationItem.vue?vue&type=template&id=a25437cc&scoped=true&lang=html"
import script from "./OrganizationItem.vue?vue&type=script&lang=js"
export * from "./OrganizationItem.vue?vue&type=script&lang=js"
import style0 from "./OrganizationItem.vue?vue&type=style&index=0&id=a25437cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25437cc",
  null
  
)

export default component.exports